module.exports = __webpack_public_path__ + "r-sales.png?6f483d131b88e7b59ed4e1c3617175b7";